import React from "react";
import { RotaButton, RotaModal, colors } from "@teamrota/rota-design";

import {
  StyledBinIconWrap,
  StyledMainText,
  StyledRedBar,
  StyledSubText,
  StyledButtonWrapper
} from "~/src/containers/roles/styles";

const DeleteModal = ({
  onCancel,
  deleteRoleName,
  handleDeleteRole,
  deleteRoleId
}) => {
  return (
    <RotaModal isSmall onClose={onCancel}>
      <StyledBinIconWrap>
        <img src={"/images/bin.svg"} />
      </StyledBinIconWrap>
      <StyledMainText>
        Are you sure you want to delete the role "{deleteRoleName}"?
      </StyledMainText>
      <StyledRedBar />
      <StyledSubText>Deleting this role is not reversible.</StyledSubText>
      <StyledButtonWrapper>
        <RotaButton onClick={onCancel} variant="secondary">
          Cancel
        </RotaButton>
        <RotaButton
          onClick={() => handleDeleteRole(deleteRoleId)}
          color={colors?.red}
        >
          Delete
        </RotaButton>
      </StyledButtonWrapper>
    </RotaModal>
  );
};

export default DeleteModal;
